import { Link, useForm } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LoaderCircle } from "lucide-react";

export function LoginForm() {
  const { data, setData, post, processing, errors, reset, clearErrors } =
    useForm({
      email: "",
      password: "",
    });

  function logIn(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();
    post("/session", {
      preserveScroll: "errors",
      onStart: () => clearErrors(),
      onError: () => reset("password"),
    });
  }

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Log in to your account</CardTitle>
          {errors.email && (
            <CardDescription className="text-destructive">
              {errors.email}
            </CardDescription>
          )}
        </CardHeader>
        <CardContent>
          <form onSubmit={logIn}>
            <div className="grid gap-6">
              <div className="grid gap-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  required
                  value={data.email}
                  onChange={(e) => setData("email", e.target.value)}
                />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="password">Password</Label>

                <Input
                  id="password"
                  type="password"
                  name="password"
                  required
                  value={data.password}
                  onChange={(e) => setData("password", e.target.value)}
                />
              </div>

              <Button type="submit" className="w-full" disabled={processing}>
                {processing && <LoaderCircle className="animate-spin" />}
                Log in
              </Button>

              <div className="text-center">
                <Link
                  href="/passwords/new"
                  className="text-sm underline-offset-4 hover:underline"
                >
                  Forgot your password?
                </Link>
              </div>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
